import type { HTMLAttributes } from 'react';
import { cn } from '@worldcoo/ui/lib/utils';

/**
 * Responsive baseline for the redesigned site (Figma breakpoints: desktop 1440
 * / mobile 375). `font-brand` (Rethink Sans) and `text-ink` are the page defaults;
 * pages compose sections inside <Layout>.
 */
export function Layout(props: HTMLAttributes<HTMLElement>) {
	return <main {...props} className={cn('font-brand text-ink min-h-screen', props.className)} />;
}
